import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookLoggingService = ( createDecorator('INotebookLoggingService'));
export { INotebookLoggingService };
